/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} HelpInputs */

const en_help = /** @type {(inputs: HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Help`)
};

const fr_help = /** @type {(inputs: HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aide`)
};

const de_help = /** @type {(inputs: HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Helfen`)
};

const it_help = /** @type {(inputs: HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aiuto`)
};

const ru_help = /** @type {(inputs: HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Помощь`)
};

const es_help = /** @type {(inputs: HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ayuda`)
};

const zh_cn2_help = /** @type {(inputs: HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`帮助`)
};

const ja_help = /** @type {(inputs: HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ヘルプ`)
};

const hi_help = /** @type {(inputs: HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मदद`)
};

const pt_pt2_help = /** @type {(inputs: HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajuda`)
};

/**
* | output |
* | --- |
* | "Help" |
*
* @param {HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const help = /** @type {((inputs?: HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_help(inputs)
	if (locale === "de") return de_help(inputs)
	if (locale === "it") return it_help(inputs)
	if (locale === "ru") return ru_help(inputs)
	if (locale === "es") return es_help(inputs)
	if (locale === "zh-CN") return zh_cn2_help(inputs)
	if (locale === "ja") return ja_help(inputs)
	if (locale === "hi") return hi_help(inputs)
	if (locale === "pt-PT") return pt_pt2_help(inputs)
	return en_help(inputs)
});